<template>
    <router-view />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    computed: {
        ...mapGetters('base', {
            selectedProduct: 'selectedProduct',
        }),
    },
    methods: {
        ...mapActions('originacao', {
            updateBaseData: 'updateBaseData',
            getSegments: 'getSegments',
            getStates: 'getStates',
            listUsers: 'listUsers',
        }),
    },
    async created() {
        this.getStates();
        this.listUsers({ id: 2 });

        this.updateBaseData({
            selectedProduct: { ...this.selectedProduct },
        });
        await this.getSegments({ id_produto: this.selectedProduct.id });
    },
};
</script>
